export default "__VITE_ASSET__8OSfdFH$__"